<template>
  <div class="school-year" :class="{'white-theme': whiteTheme}">
    <select
      v-if="schoolYears.length > 1"
      class="school-year__select"
      :value="activeSchoolYear.id"
      @change="setActiveSchoolYear($event.target.value)">
      <option v-for="year in schoolYears" :key="year.id" :value="year.id">{{ year.name }}</option>
    </select>
    <div v-else class="school-year__active">
      <p>{{ activeSchoolYear.name }}</p>
    </div>
  </div>
</template>

<script>
  export default {
    props: {
      whiteTheme: {
        type: Boolean,
        default: false
      }
    },
    computed: {
      schoolYears () {
        return this.$store.state.activeSchoolYears
      },
      activeSchoolYear () {
        return this.$store.state.localActivatedSchoolYear
      }
    },
    watch: {
      activeSchoolYear (val) {
        this.$emit('yearChange', val)
      }
    },
    methods: {
      setActiveSchoolYear (schoolYearId) {
        this.$store.commit('setlocalActivatedSchoolYear', schoolYearId)
      }
    }
  }
</script>

<style scoped>
  @import '../../assets/css/variables.css';

  .school-year__select,
  .school-year__active {
    display: flex;
    align-items: center;
    padding: 5px 10px;
    border-radius: 3px;
    color: #ffffff;
    margin: 0 auto;
    height: 26px;
    font-size: 11px;
    justify-content: center;
    background: rgba(255, 255, 255, 0.2);
    font-weight: bold;
    user-select: none;
    transition: background-color .15s, color 0.15s;
  }

  .school-year__select {
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    border: none;
    cursor: pointer;
    text-align: left;
    padding-right: 20px;
    background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAALCAYAAAFpFr+XAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAWdJREFUeNpi6OzsjAFihv///4MxEwMDwxIg/s8ABQABxAiSBYGysjIwzcSABgACCKYCpIURRANVMiIrAAggkIIQIL0Gyj8MVGCLrIAFiGcAMTcQzwdiQ3QrQApEgPgdEOsC8VV0BQABBLLiJpBWA+IEIF6IJPcPJI/uJnQA8pU61AN9UM/8g9L6UHG8gBEUepQAgAACeeEwkLbFIgcKPQ6gF5YQ8oINEP9BE08B4tVAXEfIBUzQoGdGMiQLiGcD8Wto4OIFoGi6AMRGQHwOaggzVLMYMWEAS1vngdgEqvkVsZqpEgsAAQaKhQ9Amh+I/wJxMlpiwgYSoWEEcu1HYCwJUOIAUBA4APEbqIELoOEYj0VtGjSRzoOqfQPVy0CpA0CRKAqNyHdYHJIDtXgmNGe8huYSUaheigALEhuUEIShDtkDxIJQh8AAKHE4YSsQKA0BdABKzkLQVPkQiG8DsTYQi1PbchAAAECQW0YytHmoAAAAAElFTkSuQmCC);
    background-repeat: no-repeat;
    background-position: 100% 50%;
    background-size: 16px auto;
    line-height: 1;
    width: 100%;
  }

  .school-year__select:hover {
    background-color: rgba(255, 255, 255, 0.35);
  }

  .school-year__select option {
    color: var(--dark-blue);
    background: white;
    font-weight: bold;
  }

  .white-theme .school-year__select,
  .white-theme .school-year__active {
    border: 1px solid #ccc;
    background-color: white;
    color: var(--dark-blue);
  }

  .white-theme .school-year__select:hover {
    background-color: #f6f7f8;
  }
</style>



// WEBPACK FOOTER //
// ChangeSchoolYear.vue?f8baa99e